import(/* webpackMode: "eager" */ "/vercel/path0/app/home/page.tsx");
